import script from "./Sub5.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sub5.vue?vue&type=script&setup=true&lang=ts"

import "./Sub5.vue?vue&type=style&index=0&id=3807ca4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3807ca4c"]])

export default __exports__